import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchUserNumberMessage,
  fetchUserNumberMessages,
  fetchUserNumberMessageNumbers,
  fetchConversations,
  fetchConversationMessages,
  ConversationItem,
} from "../../actions/callrecorder/userNumberMessagesActions";

export interface UserNumberMessageInterface {
  url: string;

  id: number;
  user_id: number;
  user_number_id: number;
  direction: string;
  from_number: string;
  to_number: string;
  body: string;
  twilio_sid: string | null;
  status: string | null;
  cost: string | null;
  readed: boolean;

  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
  numbers: string[];
  numbersStatus: 'idle' | 'loading' | 'succeeded' | 'failed';
  conversations: ConversationItem[];
  conversationsStatus: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
  numbers: [],
  numbersStatus: 'idle',
  conversations: [],
  conversationsStatus: 'idle',
};

const adaptor = createEntityAdapter<UserNumberMessageInterface>();

const slice = createSlice({
  name: 'userNumberMessages',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchUserNumberMessages.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchUserNumberMessages.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.userNumberMessages;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchUserNumberMessages.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #conversation messages
      .addCase(fetchConversationMessages.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchConversationMessages.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.userNumberMessages;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchConversationMessages.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #numbers
      .addCase(fetchUserNumberMessageNumbers.pending, (state) => {
        state.numbersStatus = 'loading';
      })
      .addCase(fetchUserNumberMessageNumbers.fulfilled, (state, action) => {
        state.numbers = action.payload;
        state.numbersStatus = 'succeeded';
      })
      .addCase(fetchUserNumberMessageNumbers.rejected, (state) => {
        state.numbersStatus = 'failed';
      })

      // #conversations
      .addCase(fetchConversations.pending, (state) => {
        state.conversationsStatus = 'loading';
      })
      .addCase(fetchConversations.fulfilled, (state, action) => {
        state.conversations = action.payload;
        state.conversationsStatus = 'succeeded';
      })
      .addCase(fetchConversations.rejected, (state) => {
        state.conversationsStatus = 'failed';
      })

      // #show
      .addCase(fetchUserNumberMessage.fulfilled, (state, action) => {
        const record = Object.values(action.payload.userNumberMessage)[0];
        state.entities[record.id] = record;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectUserNumberMessageById,
  selectIds: selectUserNumberMessageIds,
  selectEntities: selectUserNumberMessageEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.userNumberMessages);
